import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { FONT_FAMILY_MAIN, NOTES_COLOR } from '../../../theme';

const List = styled.ul`
  list-style: none;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  position: absolute;
  top: ${(props) => (props.isMobileView ? 'auto' : '16px')};
  left: ${(props) => (props.isMobileView ? 'auto' : '16px')};
  bottom: ${(props) => (props.isMobileView ? '0' : 'auto')};
  right: ${(props) => (props.isMobileView ? '0' : 'auto')};
  margin: 0;
  z-index: 10;
  font-family: ${FONT_FAMILY_MAIN};
`;

const Item = styled.li`
  position: relative;
  padding-left: 24px;
  font-size: 14px;
  letter-spacing: -0.13px;
  color: ${NOTES_COLOR};

  & + & {
    margin-top: 8px;
  }

  &::before {
    content: '';
    width: 16px;
    height: 16px;
    border-radius: 16px;
    background-color: ${(props) => props.color || NOTES_COLOR};
    position: absolute;
    top: 3px;
    left: 0;
  }
`;

const EXAM_CENTERS = [
  {
    name: 'Codengo',
    color: '#acc840',
  },
  {
    name: 'Dekra',
    color: '#008b4d',
  },
  {
    name: 'La Poste',
    color: '#fec801',
  },
  {
    name: 'Pointcode',
    color: '#1382a3',
  },
  {
    name: 'ObjectifCode',
    color: '#f69138',
  },
  // {
  //   name: 'Exacode',
  //   color: '#ed1651',
  // }, {
  //   name: 'France Code',
  //   color: '#fb0b0c',
  // },
];

const Legend = ({ isMobileView }) => (
  <List isMobileView={isMobileView}>
    {EXAM_CENTERS.map((el) => (
      <Item color={el.color} key={el.name}>
        {el.name}{' '}
      </Item>
    ))}
  </List>
);

Legend.propTypes = {
  isMobileView: PropTypes.bool,
};

Legend.defaultProps = {
  isMobileView: false,
};

export { Legend };
